import React, {Component} from 'react';
import '../../App.css';
import TechexpresswayFaqContent from '../TechexpresswayFaqContent';

function TechexpresswayFaq() {
    return (
      <>
          <TechexpresswayFaqContent/>
      </>
    )
  }

export default TechexpresswayFaq;